import { render, staticRenderFns } from "./DebtCollectorsAssign.vue?vue&type=template&id=5beba131&"
import script from "./DebtCollectorsAssign.vue?vue&type=script&lang=js&"
export * from "./DebtCollectorsAssign.vue?vue&type=script&lang=js&"
import style0 from "./DebtCollectorsAssign.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports